<div class="innerpage-fullwithbanner">
  <h2 class="bighead">Listings <span class="offerstatus">{{rowCount|number}}</span></h2>
  <ul class="bread-crumbs">
    <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
    <li><span>My Deals <span style="padding:8px;">|</span></span></li>
    <li>Listings</li>
  </ul>
</div>
<div class="featuredproperties section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="border-div list-box table-fixed margin0">
      <div class="tabstyle2 offerdetailstab-padding pos-relative">
        <ul class="switchingproperty margin-bottom-15 offerlistingtab">
          <li [class.active]="activeTab == tabs.OnMarket">
            <a href="javascript:void(0);" (click)="onTabClick(tabs.OnMarket)">
              On Market
            </a>
          </li>
          <li [class.active]="activeTab == tabs.OffMarket">
            <a href="javascript:void(0);" (click)="onTabClick(tabs.OffMarket)">
              Off Market
            </a>
          </li>
        </ul>
        <div class="absolutesearch">
          <div class="floatinghead clearfix">
            <div class="rightside clearfix">
              <div id="divAdvanceBlock" class="btn-group select-dropdown clearfix margin-right-15 margin-bottom-15" dropdown #dropdown="bs-dropdown" [autoClose]="false">
                <button dropdownToggle type="button" id="btnAdvanceBlock" class="box-advacned-search btn margin-left-10 margin-right-10" area-expanded="true">
                  Offer Status<span class="caret"></span>
                </button>
                <div *dropdownMenu id="dropdown-triggers-manual" class="dropdown-menu listing_dropdowndiv dropdown-menu-right dropdown-div mega-dropdown advanced-serch-dropdown" (click)="$event.stopPropagation()">
                  <div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">

                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group margin-bottom-20">
                              <label class="form-label">Offer Status</label>
                              <div class="select-dropdown multiselectdesign">
                                <mat-form-field>
                                  <mat-select placeholder="Select Status" 
                                                      [(ngModel)]="selectedStatus"
                                                      multiple>
                                    @if (selectedStatus?.length > 1) {
                                      <mat-select-trigger>
                                        <span>{{ selectedStatus?.length }} items selected</span>
                                      </mat-select-trigger>
                                    }
                                    @for (state of inputStates; track state) {
                                      <mat-option [value]="state.id" class="multi-dropdown-item">{{state.name}}</mat-option>
                                    }
                                    @if (inputStates.length === 0) {
                                      <mat-option class="matoptionnodata" disabled>
                                        Nothing found...
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4 col-sm-6 col-xs-12">
                            <div class="text-right d-flex btn-search-btm align-item-center">
                              <button class="btn-lg btn-border btn adduserbtn" (click)="reset();dropdown.hide();">Reset</button>
                              <button class="btn-lg btn btn-success" (click)="advanceSearch();dropdown.hide();">Search</button>
                            </div>
                          </div>
                          <a href="javascript:void(0);" (click)="dropdown.hide();" placement="right" class="remove pull-right">
                            <i class="icofont icofont-close" aria-hidden="true"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rightside clearfix">
              <div class="search-sec">
                <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" [(ngModel)]="searchText" placeholder="Search">
                <i class="fa fa-search icon" aria-hidden="true"></i>
              </div>
            </div>
            <div class="rightside clearfix">
              <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown pull-right" *ngIf="activeTab == tabs.OnMarket">
                <mat-form-field>
                  <mat-select placeholder="Select Columns" 
                              [(ngModel)]="selectedColumns"
                              (ngModelChange)="onChange($event);"
                              multiple>
                              <mat-select-trigger>
                                <span>Select Columns</span>
                              </mat-select-trigger>
                    @for (column of tableColumns; track column) {
                      <mat-option [value]="column.id" class="multi-dropdown-item">{{column.name}}</mat-option>
                    }
                    @if (tableColumns.length === 0) {
                      <mat-option class="matoptionnodata" disabled>
                        Nothing found...
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown pull-right" *ngIf="activeTab == tabs.OffMarket">
                <mat-form-field>
                  <mat-select placeholder="Select Columns" 
                              [(ngModel)]="selectedColumns1"
                              (ngModelChange)="onChange($event);"
                              multiple>
                              <mat-select-trigger>
                                <span>Select Columns</span>
                              </mat-select-trigger>
                    @for (column of tableColumns1; track column) {
                              <mat-option [value]="column.id" class="multi-dropdown-item">{{column.name}}</mat-option>
                    }
                    @if (tableColumns1.length === 0) {
                      <mat-option class="matoptionnodata" disabled>
                        Nothing found...
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="floatinghead clearfix">
        <div class="rightside clearfix">
          <div *ngIf="(this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin)|| this.authService.IsUserRole(this.authService.UserRole.SuperAdmin))" class="btn-group right-btn rightdropdown margin-right-10 adduserbtn" dropdown>
            <button id="button-basic" dropdownToggle type="button" class="right-btn btn-border margin-right-10 btn adduserbtn dropdown-toggle"
                    aria-controls="dropdown-basic">
              Share
            </button>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
                role="menu" aria-labelledby="button-basic">
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForShareListing(ShareListing,'panlestyle');">Share Listings</a></li>
              <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForShareOM(ShareOM,'portfolio-bov-modal shareom-document-modal');">Share OM</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions" style="min-width:950px;">
          <thead>
            <tr>
              <th data-orderable="false">
                <label class="custom-checkbox withoutlabel">
                  <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>
                </label>
              </th>
              <th *ngIf="authService.Broker()">Property Id</th>
              <th>Tenant Name</th>
              <th [hidden]="hideColumn(11)">Salesforce</th>
              <th>State</th>
              <th>City</th>
              <th [hidden]="hideColumn(14)">Share Prospects with Seller</th>
              <th [hidden]="hideColumn(1)">Asking Price</th>
              <th [hidden]="hideColumn(2)">Offers</th>
              <th [hidden]="hideColumn(3)">Seller Name</th>
              <th [hidden]="hideColumn(4)">Files</th>
              <th [hidden]="hideColumn(13)">Prospects</th>
              <th [hidden]="hideColumn(5)">Rent NOI</th>
              <th [hidden]="hideColumn(6)">Credit Rating</th>
              <th [hidden]="hideColumn(7)">Cap Rate</th>
              <th [hidden]="hideColumn(8)">Remaining Term</th>
              <th [hidden]="hideColumn(9)">Lease Structure</th>
              <th [hidden]="hideColumn(10)">Area (SQ FT)</th>
              <th [hidden]="hideColumn(12)">Last Verified Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let prop of properties;let i = index ">
              <td class="first-td">
                <label class="custom-checkbox withoutlabel">
                  <input type="checkbox" [(ngModel)]="prop.IsSelected" (change)="onCheckboxChange($event,prop.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
                </label>
              </td>
              <td *ngIf="authService.Broker()"><p>{{prop.PropertySequenceId}}</p></td>
              <td>
                <p class="whitespacenowrap"><a href="javascript:void(0);" routerLink="/viewproperty/{{prop.Slug ? prop.Slug : prop.Guid}}" [queryParams]="{prevroute:'my-listings',link:router.url,dealTab:activeTab}">{{prop.PropertyName}}</a></p>
                <p>{{prop.FullAddress}}</p>
              </td>
              <td [hidden]="hideColumn(11)">
                <span *ngIf="prop.SalesforceId == null"> - </span>
                <a *ngIf="prop.SalesforceId != null" class="bluelink sf-link" href="{{prop.SalesforceLink}}" target="_blank">{{prop.SalesforceId}}</a>
              </td>
              <td><p>{{prop.State ? prop.State : '-'}}</p></td>
              <td><p style="width:100px">{{prop.City ? prop.City : '-'}}</p></td>
              <td [hidden]="hideColumn(14)" style="text-align:center">
                <label class="custom-checkbox withoutlabel">
                  <input type="checkbox" [(ngModel)]="prop.ShowProspectToSeller" (ngModelChange)="setSellerPrivilage(prop.ShowProspectToSeller,prop.Id)" class="ng-pristine ng-valid ng-touched"><i></i>
                </label>
              </td>
              <td [hidden]="hideColumn(1)">
                <p *ngIf="!prop.Unpriced" class="whitespacenowrap">{{(prop.Price!=null&&prop.Price>=0) ? '$ '+ (prop.Price | number:0) : '-'}}</p>
                <p *ngIf="prop.Unpriced" class="whitespacenowrap">Unpriced</p>
              </td>
              <td [hidden]="hideColumn(2)"><p>{{prop.OffersCount>=0 ? prop.OffersCount : '-'}}</p></td>
              <td [hidden]="hideColumn(3)" class="tool-top-box pos-relative"><p style="width:100px" placement="left" tooltip="{{prop.Sellers}}">{{Gettooltipcontent(prop.Sellers)}}</p></td>
              <td [hidden]="hideColumn(4)"><p>{{ prop.TotalFileCount>=0 ? prop.TotalFileCount  : '-' }}</p></td>
              <td [hidden]="hideColumn(13)"><p>{{ prop.Prospects>=0 ? prop.Prospects  : '-' }}</p></td>
              <td [hidden]="hideColumn(5)"><p style="width:100px">{{(prop.RentNOI) ? '$ '+ (prop.RentNOI | number:0) : '-'}}</p></td>
              <td [hidden]="hideColumn(6)"><p>{{ prop.Rating ? prop.Rating  : '-' }}</p></td>
              <td [hidden]="hideColumn(7)">
                <p *ngIf="!prop.CharacteristicsId">{{ prop.CapRate ? prop.CapRate + '%' : '-'}}</p>
                <p *ngIf="prop.CharacteristicsId">ZCF</p>
              </td>
              <td [hidden]="hideColumn(8)"><p>{{ prop.Remaining_Term ? prop.Remaining_Term : '-'}}</p></td>
              <td [hidden]="hideColumn(9)"><p>{{ prop.LeaseStructure ? prop.LeaseStructure : '-'}}</p></td>
              <td [hidden]="hideColumn(10)"><p>{{ prop.BuildingSize ? (prop.BuildingSize | number:0) : '-' }}</p></td>
              <td [hidden]="hideColumn(12)">
                <p class="whitespacenowrap">{{prop.LastVerifiedDate ? (Validation.convertUTCDateToLocalDate(prop.LastVerifiedDate)| date:'MM/dd/yyyy'): '-' }}</p>
              </td>

            </tr>
          </tbody>
          <tfoot>
            <tr *ngIf="properties?.length == 0 &&!IsLoading">
              <td attr.colspan="{{tdcount}}" class="odd no-data-available" colspan="11">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Properties to Display</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #ShareOM>
  <app-share-omdocuments [propertyIds]="sharedOmProperties" [modalRefShareListing]="modalRefOM" (removeProperties)="removeProperty($event)"></app-share-omdocuments>
</ng-template>
<ng-template #ShareListing>
  <app-share-group-add [selectedProperties]="selectedProperties" [modalRefShareListing]="modalRefShareListing" (removeProperties)="removeProperty($event)"></app-share-group-add>
</ng-template>
